import { CollegeData } from "components/CollegeSearch"
import { HighSchoolData } from "components/HighSchoolSearch"
import ApiRoot from "./apiRoot"

export class CustomSearch extends ApiRoot {
  private static getAuthToken(token: string | string[]): string {
    return Array.isArray(token) ? token[0] : token
  }

  static highSchoolSearch(
    query: string,
    token: string | string[]
  ): Promise<void |  {
    status: string | number
    data: HighSchoolData[]
  }> {
    let queryString = `?query=${query}`
    if (!this.connection) {
      throw new Error("High school search connection not established")
    }
    if (!token) {
      throw new Error("Token is required for high school search")
    }
    return this.connection
      .get(`/lookup/ceeb${queryString}`, {
        headers: {
          Authorization: `Bearer ${this.getAuthToken(token)}`,
        },
      })
      .then(res => {
        return {
          status: res.status,
          data: res.data,
        }
      })
      .catch(error => {
        console.log(error)
        return undefined
      })
  }

  static collegeSearch(
    query: string,
    token: string | string[]
  ): Promise<void | {
    status: string | number
    data: CollegeData[]
  }> {
    let queryString = `?query=${query}`
    if (!this.connection) {
      throw new Error("College search connection not established")
    }
    if (!token) {
      throw new Error("Token is required for college search")
    }
    return this.connection
      .get(`/lookup/college-codes${queryString}`, {
        headers: {
          Authorization: `Bearer ${this.getAuthToken(token)}`,
        },
      })
      .then(res => {
        return {
          status: res.status,
          data: res.data,
        }
      })
      .catch(error => {
        console.log(error)
        return undefined
      })
  }
}
